module.exports = __webpack_public_path__ + "img/login-logo.684d2144.png";